import React from 'react';
import { Button, Text } from '@rneui/themed';
import { useOnNavigate } from '../hooks';
export const NotFound = () => {
    const onNavigate = useOnNavigate();
    return (React.createElement("div", { style: { textAlign: 'center', maxWidth: 300, margin: 'auto', marginTop: 70 } },
        React.createElement(Text, { h1: true }, "NOT FOUND"),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement(Text, null, "Sorry! This page could not be found. Perhaps an old or mis-linked page?"),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement(Button, { onPress: () => onNavigate('/') }, "Go Home"),
        React.createElement("br", null),
        React.createElement(Button, { type: "outline", onPress: () => onNavigate('back') }, "Go Back")));
};
//# sourceMappingURL=NotFound.js.map